// AC-defined page type value set for B2B portal.
export type PageType =
  | 'home'
  | 'category'
  | 'search results'
  | 'product'
  | 'cart'
  | 'checkout'
  | 'purchase'
  | 'my account'
  | 'buying lists'
  | 'quotes'
  | 'content'
  | 'support'
  | 'other';

/**
 * Maps a locale-stripped pathname (from `usePathname()` in @/i18n/routing)
 * and optional search query string to the GA4 page_type value.
 * Verify URL prefixes match the portal's actual Frontastic routes before
 * shipping — slug-based routes may differ from these defaults.
 */
export function getPageType(pathname: string, searchQuery?: string | null): PageType {
  if (searchQuery) return 'search results';
  if (pathname === '/') return 'home';
  if (/\/p\/[^/]+/.test(pathname)) return 'product';
  if (pathname.startsWith('/cart')) return 'cart';
  if (pathname.startsWith('/checkout')) return 'checkout';
  if (
    pathname.startsWith('/order-confirmed') ||
    pathname.startsWith('/thank-you') ||
    pathname.startsWith('/order-success')
  )
    return 'purchase';
  if (pathname.startsWith('/account') || pathname.startsWith('/my-account')) return 'my account';
  if (pathname.startsWith('/purchase-lists')) return 'buying lists';
  if (pathname.startsWith('/quotes')) return 'quotes';
  if (pathname.startsWith('/search')) return 'search results';
  if (pathname.startsWith('/support')) return 'support';
  if (pathname.startsWith('/c/') || pathname.startsWith('/category/')) return 'category';
  return 'other';
}
